import axios from "axios";
import { API } from "../../const";
import { normParam, serverTime } from "@/tools";

const M_API = API;
const store = {
  namespaced: true,
  state: {
    diklat_id: null,
    diklat: [],
    diklatku: []
  },
  getters: {
    diklat_id(state) {
      return state.diklat_id;
    },
    diklat(state) {
      return state.diklat;
    },
    diklatku(state) {
      return state.diklatku;
    }
  },
  mutations: {
    setDiklatId(state, val) {
      state.diklat_id = val;
    },
    setDiklat(state, val) {
      state.diklat = val;
    },
    setDiklatku(state, val) {
      state.diklatku = val;
    }
  },
  actions: {
    // eslint-disable-next-line
    get({ state, commit }, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getDiklats({ state }, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklats`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return (state.diklat = res.data);
        });
    },
    // eslint-disable-next-line
    getDiklatku({ commit }, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklatku${normParam(params)}`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          commit("setDiklatku", res.data);
          res.data.forEach(d => {
            d.server_time = serverTime(res);
          });
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    switchDiklat({ state, commit, dispatch }, { instansi_id, diklat_id }) {
      // cek apakah perlu load ulang instansi
      if (state.diklat_id == diklat_id) {
        return state.diklat_id;
      } else {
        return dispatch(
          "kelas/get",
          {
            instansi_id: instansi_id,
            diklat_id: diklat_id
          },
          { root: true }
        ).then(() => {
          state.diklat_id = diklat_id;
          // reject jika instansi tidak ditemukan
          // if (res.id) {
          //   state.diklat = res.id;
          //   commit("main/noInstansi", false, {
          //     root: true
          //   });
          // } else {
          //   commit("main/noInstansi", true, {
          //     root: true
          //   });
          //   return Promise.reject();
          // }
        });
      }
    },

    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/diklat/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/diklat`, obj)
          .then(res => {
            // dispatch("akses", instansi_id);
            return res;
          })
          .catch(e => e);
      }
    },
    drop(_, { instansi_id, diklat_id }) {
      return axios.delete(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}`).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
